import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'common/components/elements/buttons/primary';
import Select from 'common/components/modules/select';
import ViewAsModal from 'common/components/modules/view-as';
import { ConfirmationModal } from 'admin/views/site-designer/modules';
import { getGlobalSettingsOnPopup, PAGE_SEGMENT_KEY, MENU_SEGMENT_KEY } from 'admin/views/site-designer/data';
import Router from 'admin/routes/router';

const SiteDesigner = ({
   selectedPage,
   pages,
   onSelectPage,
   publishDraftContent,
   fetchPublishDraftContent,
   onSelectGlobalSettings,
   goTo,
   currentSegment,
}) => {
   const [openViewAsModal, setOpenViewAsModal] = useState(false);
   const [openPublishConfirmModal, setOpenPublishConfirmModal] = useState(false);
   const getSelectedPage = () => {
      if(currentSegment?.type ===  PAGE_SEGMENT_KEY || (currentSegment?.type ===  MENU_SEGMENT_KEY && selectedPage?.is_system)){
         return selectedPage || {};
      }

      return {};
   }
   return (
      <div className='fixed top-0 bg-panel px-6 py-[10px] rounded-[1px] border-b border-divider flex justify-between w-full z-10'>
         {
            openPublishConfirmModal && (
               <ConfirmationModal
                  title='Publish'
                  description='Publish'
                  buttonText='Yes'
                  icon='views'
                  iconColor='action'
                  onClose={ _ => setOpenPublishConfirmModal(false) }
                  action={ _ => {
                     publishDraftContent(() => {
                        setOpenPublishConfirmModal(false);
                     })
                  } }
                  isLoading={ fetchPublishDraftContent }
               />
            )
         }
         <div className='flex gap-[83px]'>
            <div className='flex items-center gap-6'>
               <div className='h-10 w-10'>
                  <Button
                     borderRadius='large'
                     iconName='exit'
                     backgroundColor='transparent'
                     fontIconColor='secondary'
                     classNames='border border-divider w-full h-full justify-center items-center hover:bg-grey-main'
                     textMarginX='0'
                     padding='0'
                     onClick={ _ =>  goTo(Router.route('HOMEPAGE').getCompiledPath()) }
                  />
               </div>
               <span className='font-bold text-sxl text-major leading-[24px]'>Site designer</span>
            </div>
            <div className='flex gap-3'>
               {
                  Boolean(pages && pages.length) && (
                     <div className='flex max-w-[320px] min-w-[257px]'>
                        <Select
                           isMobile={ false }
                           tooltipId='site_design_page_select'
                           data={ pages }
                           onSelect={ (activeOption) => onSelectPage(activeOption) }
                           activeValue={  getSelectedPage()?.uuid || null }
                           maxHeight='400px'
                           className='w-full hover:bg-grey-main'
                           leftIcon={ getSelectedPage()?.icon || null }
                           name={ getSelectedPage()?.name || null }
                           keys={ {
                              name: 'name',
                              value: 'uuid',
                           } }
                        />
                     </div>
                  )
               }
               <div className='h-10 flex max-w-[163px]'>
                  <Button
                     borderRadius='large'
                     iconName='arrow-down'
                     secondIconName='views'
                     backgroundColor='transparent'
                     fontIconColor='secondary'
                     classNames='border border-divider w-full h-full justify-center items-center hover:bg-grey-main'
                     // textMarginX='0'
                     textMarginExistSecondIcon='2'
                     padding=' px-[14px]'
                     text='View as'
                     textColor='major'
                     textSize='base'
                     onClick={ () => setOpenViewAsModal(true) }
                     fontWeight='normal'
                     disabled
                  />
               </div>
               <div className='flex max-w-[320px] min-w-[180px]'>
                  <Select
                     isMobile={ false }
                     tooltipId='site_design_global_settings'
                     data={ getGlobalSettingsOnPopup() }
                     onSelect={ (activeOption) =>  onSelectGlobalSettings(activeOption) }
                     maxHeight='400px'
                     className='w-full hover:bg-grey-main'
                     name='Global settings'
                     keys={ {
                        name: 'name',
                        value: 'type',
                     } }
                  />
               </div>
               {
                  openViewAsModal && (
                     <ViewAsModal
                        onCloseModal={ () => setOpenViewAsModal(false) }
                        // pricings={ siteInfo.pricings }
                        goToView={ (data) => {
                           //
                        } }
                        // isMobile={ screenWidth < 701 }
                        isShowVisitor={ true }
                     />
                  )
               }

            </div>
         </div>


         <div className='h-9 '>
            <Button
               text='Publish'
               borderRadius='large'
               primaryColor
               textMarginX='0'
               padding='0 px-[18px]'
               classNames='h-full'
               textSize='small'
               onClick={ _ => setOpenPublishConfirmModal(true) }
               // disabled
            />
         </div>
      </div>
   )
}

SiteDesigner.propTypes = {
   selectedPage: PropTypes.object,
   onSelectPage: PropTypes.func,
   publishDraftContent: PropTypes.func,
   onSelectGlobalSettings: PropTypes.func,
   goTo: PropTypes.func,
   pages: PropTypes.array,
   fetchPublishDraftContent: PropTypes.bool,
   currentSegment: PropTypes.object,
};
export default SiteDesigner;
